<template>
  <div>    
    <div class="main" style="background-image:url(static/img/act/7/banner/bg.jpg)" @click="playMusic()">
      <div class="act-7-banner-title-wrap">
        <img class="act-7-banner-title-bg " src="static/img/act/7/banner/title-bg.png">   
        <img v-show="isShow" class="act-7-banner-title act-7-animation-banner-title" src="static/img/act/7/banner/title.png">  
        <img v-show="isShow" class="act-7-banner-title-desc act-7-animation-banner-title-desc" src="static/img/act/7/banner/title-desc.png">   
        <img v-show="isShow" class="act-7-banner-title-contents act-7-animation-banner-title-contents" src="static/img/act/7/banner/title-contents.png">             
        <img v-show="isShow" class="act-7-banner-dragonfly act-7-animation-dragonfly" src="static/img/act/7/banner/dragonfly.png">   
      </div> 
      <div class="act-7-banner-lotus-wrap">
        <img v-show="isShow" @click="displayWindow1" class="act-7-banner-btn-mtj act-7-animation-banner-btn-mtj" src="static/img/act/7/banner/btn-mtj.png"> 
        <img class="act-7-banner-lotus-1 act-7-animation-lotus-1" src="static/img/act/7/banner/lotus-1.png">    
        <img v-show="isShow" @click="displayVideo" class="act-7-banner-btn-spj act-7-animation-banner-btn-spj" src="static/img/act/7/banner/btn-spj.png"> 
        <img v-show="isShow" @click="displaySsj" class="act-7-banner-btn-ssj act-7-animation-banner-btn-ssj" src="static/img/act/7/banner/btn-ssj.png"> 
        <img v-show="isShow" @click="displayYyj" class="act-7-banner-btn-yyj act-7-animation-banner-btn-yyj" src="static/img/act/7/banner/btn-yyj.png">  

        <img class="act-7-banner-fish" src="static/img/act/7/banner/fish.png">      
        <img class="act-7-banner-lotus-leaves" src="static/img/act/7/banner/lotus-leaves.png">   
        <img class="act-7-banner-lotus-2 act-7-animation-lotus-2" src="static/img/act/7/banner/lotus-2.png">         
        <img class="act-7-banner-lotus-3 act-7-animation-lotus-2" src="static/img/act/7/banner/lotus-3.png">     
        <img class="act-7-banner-lotus-4 act-7-animation-lotus-1" src="static/img/act/7/banner/lotus-4.png">    
        <img class="act-7-banner-leaves-1" src="static/img/act/7/banner/leaves-1.png">     
        <img class="act-7-banner-leaves-2" src="static/img/act/7/banner/leaves-2.png">    
        <img class="act-7-banner-leaves-3" src="static/img/act/7/banner/leaves-3.png">   
        <img class="act-7-banner-leaves-4" src="static/img/act/7/banner/leaves-4.png">  
        
        <div @click="displayWindow1" class="act-7-banner-btn-mtj act-7-banner-btn-layer" ></div> 
        <div @click="displayVideo" class="act-7-banner-btn-spj act-7-banner-btn-layer" ></div>  
        <div @click="displaySsj" class="act-7-banner-btn-ssj act-7-banner-btn-layer" ></div>  
        <div @click="displayYyj" class="act-7-banner-btn-yyj act-7-banner-btn-layer" ></div>  
      </div>
      <!-- 美图卷 -->
       <transition name="fade">
        <div v-show="isWindow1Show" class="act-7-main-widnow-mtj">
          <img src="static/img/act/7/banner/window-mtj.png" class="act-7-main-widnow-mtj-bg">   
          <img @click="closeWindow1" src="static/img/act/7/banner/btn-close.png" class="act-7-main-widnow1-btn-close" > 
          <div class="act-7-main-widnow1-p1" @click="displayGallery(1)" ></div>
          <div class="act-7-main-widnow1-p2" @click="displayGallery(2)"  ></div>
          <div class="act-7-main-widnow1-p3" @click="displayGallery(3)"  ></div>
        </div>
      </transition>
      <!-- 美图卷 end-->

      <!-- 图集 -->
       <transition name="fade">
        <div v-show="isGalleryShow" class="act-7-main-gallery">
          <img src="static/img/act/7/banner/window-gallery.png" class="act-7-main-widnow-mtj-bg">   
          <img @click="closeGallery" src="static/img/act/7/btn-return.png" class="act-7-main-widnow1-btn-close" >  
          <div class="act-7-main-gallery-title" v-text="galleryTitle"></div>

        
        <!-- 轮播图 3 -->
        <div class="act-7-main-gallery-swiper-wrap">
          <div class="swiper-container act-3-swiper-3">
            <div class="swiper-wrapper">
              <div v-for="(item, index) in galleryData" class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" :data-src="item.img" @click="displayPhoto(item.img)">
                <div class="swiper-lazy-preloader"></div>
              </div>
            </div>
          </div> 
        </div>
        
            <!-- Add Arrows -->
            <div class="swiper-button-next" @click="acT3Banner3Next()"></div>
            <div class="swiper-button-prev" @click="acT3Banner3Prev()"></div>
            <div class="swiper-page-info"><span v-text="galleryIndex"></span> / <span v-text="galleryTotal"></span></div>
        <!--   轮播图 3 end-->

        </div>
      </transition>
      <!-- 图集 end-->
        
      <!-- 视频卷 -->
       <transition name="fade">
        <div v-show="isVideoShow" class="act-7-main-widnow-mtj">
          <img src="static/img/act/7/banner/window-video.png" class="act-7-main-widnow-mtj-bg">   
          <img @click="closeVideo" src="static/img/act/7/banner/btn-close.png" class="act-7-main-widnow1-btn-close" > 
          <video v-if="isVideoShow" src="static/img/act/7/video/20190628.mp4" poster="static/img/act/7/video/20190628-poster.jpg" class="video" x5-playsinline="" playsinline="" webkit-playsinline="" x5-video-player-fullscreen="true" controls></video>
        </div>
      </transition>
      <!-- 视频卷 end-->

      
      <!-- 身世卷 -->
       <transition name="fade">
        <div v-show="isSsjShow" class="act-7-main-widnow-mtj">
          <img src="static/img/act/7/banner/window-ssj.png" class="act-7-main-widnow-mtj-bg">   
          <img @click="closeSsj" src="static/img/act/7/banner/btn-close.png" class="act-7-main-widnow1-btn-close" >    
          <div class="ssj-contents">
            <p>巍巍大武山、汩汩西沘河、沧桑古榕树、神奇报时泉，山灵水秀的自然环境孕育出万亩荷海，十里飘香——柳江区百朋镇怀洪村下伦屯，素有“中国玉藕之乡”的美誉，所产的莲藕嫩白如玉、清甜脆口，闻名遐迩。</p>
            <p>自2012年起，百朋每年都举办一次荷花文化旅游节，打造以“百朋玉藕”为品牌的节庆文化。眼下，以下伦屯为中心的万亩藕海荷叶飘香，朵朵荷花含苞待放，迎来了游览观赏的大好时节。</p>
            <img src="static/img/act/7/ssj/1.jpg" >
            <p>今年荷花文化旅游节首次迎来了吉祥物“荷荷”“美美”，取自“和”、“美”之意，让人向往。</p>
            <img src="static/img/act/7/ssj/2.jpg" >
          </div>       
        </div>
      </transition>
      <!-- 身世卷 end-->
      
      <!-- 友谊卷 -->
       <transition name="fade">
        <div v-show="isYyjShow" class="act-7-main-widnow-mtj">
          <img src="static/img/act/7/banner/window-yyj.png" class="act-7-main-widnow-mtj-bg">   
          <img @click="closeYyj" src="static/img/act/7/banner/btn-close.png" class="act-7-main-widnow1-btn-close" >    
          <div class="yyj-contents">
            <p>　　在柳州，荷花盛放的地方可不止百朋一处，下面就是其他赏荷地点一览，想看荷花的你可不要错过哦~</p>
            <ul>
              <li @click="displayYyjItem(1)">
                <img src="static/img/act/7/yyj/1.jpg?v=1">
                <div class="yyj-item-title">雀儿山公园</div>
              </li>
              <li @click="displayYyjItem(2)">
                <img src="static/img/act/7/yyj/2.jpg?v=1">
                <div class="yyj-item-title">柳州市园博园</div>
              </li>
              <li @click="displayYyjItem(3)">
                <img src="static/img/act/7/yyj/3.jpg?v=1">
                <div class="yyj-item-title">三江良口乡和里村</div>
              </li>
              
              <li @click="displayYyjItem(4)">
                <img src="static/img/act/7/yyj/4.jpg?v=1">
                <div class="yyj-item-title">融安县长安镇太平村</div>
              </li>
              <li @click="displayYyjItem(5)">
                <img src="static/img/act/7/yyj/5.jpg?v=1">
                <div class="yyj-item-title">蓝色梦幻香草园</div>
              </li>
              <li @click="displayYyjItem(6)">
                <img src="static/img/act/7/yyj/6.jpg?v=1">
                <div class="yyj-item-title">鹿寨荷色乡栈</div>
              </li>

            </ul>
          </div>       
        </div>
      </transition>
      <!-- 友谊卷 end-->


      <!-- 友谊卷条目内容 -->
       <transition name="fade">
        <div v-show="isYyjItemShow" class="act-7-main-widnow-mtj">
          <img src="static/img/act/7/banner/window-yyj.png" class="act-7-main-widnow-mtj-bg">   
          <img @click="closeYyjItem" src="static/img/act/7/btn-return.png" class="act-7-main-widnow1-btn-close" >  

          <div v-if="yyjItemId == 1" class="ssj-contents">
            <div class="ssj-contents-item-title">雀儿山公园</div>
            <p>柳州市区最方便的赏荷地点非雀儿山莫属，路程短，多路公交车均可到达，无需太多准备，想看，就去吧！</p>            
            <img src="static/img/act/7/yyj/1.jpg?v=1" >
            <p class="ssj-contents-item-address">赏花地址： 广西柳州市柳北区雀儿山路5号</p>         
          </div>   

          <div v-if="yyjItemId == 2" class="ssj-contents">
            <div class="ssj-contents-item-title">柳州市园博园</div>
            <p>园林与荷花的绝妙组合，尽在园博园。</p>            
            <img src="static/img/act/7/yyj/2.jpg?v=1" >
            <p class="ssj-contents-item-address">赏花地址：柳州市鱼峰区博园大道35号</p>         
          </div>   

          <div v-if="yyjItemId == 3" class="ssj-contents">
            <div class="ssj-contents-item-title">三江良口乡和里村</div>
            <p>侗家廊亭与荷花相映成趣的地方。</p>            
            <img src="static/img/act/7/yyj/3.jpg?v=1" >
            <p class="ssj-contents-item-address">赏花地址：柳州市三江良口乡和里村</p>         
          </div>   


          <div v-if="yyjItemId == 4" class="ssj-contents">
            <div class="ssj-contents-item-title">融安县长安镇太平村</div>
            <p>荷花园农庄特供：荷叶叫花鸡、莲子老鸭汤、正宗河边鱼等美味哦~</p>            
            <img src="static/img/act/7/yyj/4.jpg?v=1" >
            <p class="ssj-contents-item-address">赏花地点：融安县长安镇太平村</p>         
          </div>   
          

          <div v-if="yyjItemId == 5" class="ssj-contents">
            <div class="ssj-contents-item-title">蓝色梦幻香草园</div>
            <p>马鞭草还没看完，荷花又开了，一个地方欣赏两种花海，超值！另有月季、薰衣草、格桑花可以欣赏，还能钓螃蟹小龙虾以及烧烤哦~</p>            
            <img src="static/img/act/7/yyj/5.jpg?v=1" >
            <p class="ssj-contents-item-address">赏花地点：柳江区进德镇三千村龙胜屯25号（导航：蓝色梦幻香草园）</p>         
          </div>   
          

          <div v-if="yyjItemId == 6" class="ssj-contents">
            <div class="ssj-contents-item-title">鹿寨荷色乡栈</div>
            <p>6月至10月每周周六，这里将举办2019年荷色乡栈常态化荷花宴活动，美景与美食简直治愈你的心、俘虏你的胃！来这里走一遭，心情都能哼成歌~</p>            
            <img src="static/img/act/7/yyj/6.jpg?v=1" >
            <p class="ssj-contents-item-address">赏花地点：鹿寨县中渡镇石祥屯</p>         
          </div>   

        </div>
      </transition>
      <!-- 友谊卷条目内容 end-->
      
    <div class="lanren-wrap" id="lanren">
      <div id="audio-btn" class="on" @click="controlMusic()" >
        <audio src="static/img/act/7/video/bg.mp3" id="audio" autoplay="autoplay" preload="preload" loop="loop"></audio>	 
      </div>
    </div>

    </div>    
  </div>
</template>
 

<script>
import NavTabbar from '@/components/NavTabbar.vue' 
import { ImagePreview } from "vant";
//动画
import Velocity from "velocity-animate";
//轮播
import Swiper from 'swiper' 
import 'swiper/dist/css/swiper.min.css'

export default {
  name: "Act6Banner",
  components: {
    'nav-tabbar': NavTabbar,   
    "van-image-preview": ImagePreview
  },
  data() {
    return {
      isShow:false,
      isWindow1Show:false,
      isGalleryShow:false,
      act3Swiper3:'',      
      gallery1Data:[
        {img:'static/img/act/7/htmj/1.jpg'},
        {img:'static/img/act/7/htmj/2.jpg'},
        {img:'static/img/act/7/htmj/3.jpg'},
        {img:'static/img/act/7/htmj/4.jpg'},
        {img:'static/img/act/7/htmj/5.jpg'},
        {img:'static/img/act/7/htmj/6.jpg'},
        {img:'static/img/act/7/htmj/7.jpg'},
        {img:'static/img/act/7/htmj/8.jpg'},
        {img:'static/img/act/7/htmj/9.jpg'},
        {img:'static/img/act/7/htmj/10.jpg'},
        {img:'static/img/act/7/htmj/11.jpg'},
        {img:'static/img/act/7/htmj/12.jpg'},
        {img:'static/img/act/7/htmj/13.jpg'},
      ],
      gallery2Data:[        
        {img:'static/img/act/7/jcby/1.jpg'},
        {img:'static/img/act/7/jcby/2.jpg'},
        {img:'static/img/act/7/jcby/3.jpg'},
        {img:'static/img/act/7/jcby/4.jpg'},
        {img:'static/img/act/7/jcby/5.jpg'},
        {img:'static/img/act/7/jcby/6.jpg'},
        {img:'static/img/act/7/jcby/7.jpg'},
        {img:'static/img/act/7/jcby/8.jpg'},
        {img:'static/img/act/7/jcby/9.jpg'},
        {img:'static/img/act/7/jcby/10.jpg'},
        {img:'static/img/act/7/jcby/11.jpg'},
        {img:'static/img/act/7/jcby/12.jpg'},
        {img:'static/img/act/7/jcby/13.jpg'},

      ],
      gallery3Data:[        
        {img:'static/img/act/7/oyms/1.jpg'},
        {img:'static/img/act/7/oyms/2.jpg'},
        {img:'static/img/act/7/oyms/3.jpg'},
        {img:'static/img/act/7/oyms/4.jpg'},
        {img:'static/img/act/7/oyms/5.jpg'},
        {img:'static/img/act/7/oyms/6.jpg'},
        {img:'static/img/act/7/oyms/7.jpg'},
        {img:'static/img/act/7/oyms/8.jpg'},
        {img:'static/img/act/7/oyms/9.jpg'},
        {img:'static/img/act/7/oyms/10.jpg'},
        {img:'static/img/act/7/oyms/11.jpg'},

      ],
      galleryData:[],
      galleryIndex:1,
      galleryTotal:0,
      galleryTitle:'荷塘美景',
      swiperSlideHeight:'auto',
      /* 视频卷 */
      isVideoShow:false,
      /* 视频卷 end */
      /* 身世卷 */
      isSsjShow:false,
      /* 身世卷 end */
      
      /* 友谊卷 */
      isYyjShow:false,
      isYyjItemShow:false,
      yyjItemId:0,
      /* 友谊卷 end */
      act7FirstMusicPlay:true,
    };
  },
  destroyed(){
     document.removeEventListener("touchstart",function(){
       
     },false);
  },
  mounted() { 
    console.log('mounted')    
    
    //监听音频组件播放状态
    let vm = this
    var audio = document.getElementById("audio");
      audio.addEventListener("playing", function(){		//播放状态Doing
        console.log("app","playing");      
      });
      audio.addEventListener("pause", function(){ //暂停状态Doing
         console.log("pause")
      }); 
    document.addEventListener('touchstart', function () {   
      if( vm.act7FirstMusicPlay ) {
        vm.playMusic();   
      }
      vm.act7FirstMusicPlay = false
    });
  },
  created() {    
    console.log('created')
    let vm = this
    //移除loading
    if(this.removeLoader()){
      setTimeout(function(){
        vm.isShow = true
      },2000)   
    } else{
      vm.isShow = true
    }
    this.setDocumentV2(
      "夏日赏荷卷",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/7/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '夏日赏荷卷', '点击', '活动主页面','1','7']);  
    
    
  },
  methods: {
    
    controlMusic(){
      var audio = document.getElementById("audio");
      if(audio.paused){
        this.playMusic();          
      } else{
         this.stopMusic();         
      } 
    },
    playMusic(){
      var audio = document.getElementById("audio");
      audio.play();
      document.getElementById("audio-btn").setAttribute("class", "on");
    },
    stopMusic(){
      var audio = document.getElementById("audio");   
      audio.removeAttribute("autoplay"); //如果有自动播放autoplay属性，pause()方法不起作用，这个方式去除只是把autoplay变成FALSE
      setTimeout(function(){
         document.getElementById("audio").pause();
         document.getElementById("audio-btn").setAttribute("class", "off");
      },100)
    }, 
    initSwiper(){
      this.act3Swiper3 = [];
      let vm  = this      
      this.act3Swiper3 = new Swiper('.act-3-swiper-3', {
        autoplay:false,
        loop:true, 
        lazy: {
          loadPrevNext: true,
        },
        on:{
          slideChangeTransitionStart: function(){ 
            if(vm.act3Swiper3.realIndex || vm.act3Swiper3.realIndex == 0){
              vm.galleryIndex = vm.act3Swiper3.realIndex+1
            }
          },
        }
      })
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;  
      this.swiperSlideHeight =( w * (352.5/375) * (440.63/352.5)  * (206.53 / 440.63) ) + 'px';
    },
    displayWindow1(){
      this.isWindow1Show = true
    },
    closeWindow1(){
      this.isWindow1Show = false
    },
    displayGallery(id){
      this.galleryData = [];
      this.isGalleryShow = true 
        switch(id){
          case 1:
            this.galleryTitle = '荷塘美景';
            break;
          case 2:
            this.galleryTitle = '精彩表演';
            break;
          case 3:
            this.galleryTitle = '藕遇美食';
            break;
        }

      let vm = this;      
      try{
        this.act3Swiper3.destroy(false);
      } catch(e){

      }
      setTimeout(() => {
        switch(id){
          case 1:
            vm.galleryData = vm.gallery1Data;
            break;
          case 2:
            vm.galleryData = vm.gallery2Data;
            break;
          case 3:
            vm.galleryData = vm.gallery3Data;
            break;
        }
        vm.galleryTotal = vm.galleryData.length
        vm.galleryIndex = 1
        setTimeout(() => {
          vm.initSwiper();
        }, 200);
      }, 300);
      
    },
    closeGallery(){
      this.isGalleryShow = false
    },
      acT3Banner3Next(){ 
        
        try{
          this.act3Swiper3[1].slideNext();
        }catch(e){
           try{
          this.act3Swiper3[0].slideNext();
          
          
        }catch(e){
          this.act3Swiper3.slideNext();
        }
        }
        
      },
      acT3Banner3Prev(){ 
        
        
        try{
          this.act3Swiper3[1].slidePrev();
        }catch(e){
           try{
          this.act3Swiper3[0].slidePrev();
          
          
        }catch(e){
          this.act3Swiper3.slidePrev();
        }
        }
        
      },
    displayVideo(){
      let vm = this
      setTimeout(() => {
        vm.stopMusic();  
      }, 200);      
      this.isVideoShow = true
    },
    closeVideo(){
      this.playMusic();
      this.isVideoShow = false
    },
    displaySsj(){
      this.isSsjShow = true
    },
    closeSsj(){
      this.isSsjShow = false
    },
    displayYyj(){
      this.isYyjShow = true
    },
    closeYyj(){
      this.isYyjShow = false
    },
    displayYyjItem(id){
      this.yyjItemId = id
      this.isYyjItemShow = true
    },
    closeYyjItem(){
      this.isYyjItemShow = false
    },     
    displayPhoto(url) {
      ImagePreview({
        images: [ url ],
        showIndex:false,
        });
      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {  
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden;
}


/* 大标题 */

.act-7-banner-title-wrap {
  position: absolute;
  width: 51%;
  left: 3%;
  top: 12%;
}

.act-7-banner-title-bg {
  position: relative;
  width: 100%;
}



 
@-webkit-keyframes act-7-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes act-7-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.act-7-animation-banner-title {
  -webkit-animation-name: act-7-fadeIn;
  animation-name: act-7-fadeIn;
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-7-fadeIn 0.8s ease-in-out both;
  animation: act-7-fadeIn 0.8s ease-in-out both;
}

 
 
.act-7-banner-title {
    position: absolute;
    top: 8%;
    left: 6%;
    width: 53%;
    max-width: 100%;
}

.act-7-animation-banner-title-desc {
  -webkit-animation-name: act-7-fadeIn;
  animation-name: act-7-fadeIn;
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-7-fadeIn 0.8s ease-in-out both;
  animation: act-7-fadeIn 0.8s ease-in-out both;
  animation-delay: 300ms;
  -webkit-animation-delay: 300ms;
}

 
.act-7-banner-title-desc {
    position: absolute;
    top: 37%;
    left: 6%;
    width: 67%;
    max-width: 100%;
}

.act-7-animation-banner-title-contents {
  -webkit-animation-name: act-7-fadeIn;
  animation-name: act-7-fadeIn;
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-7-fadeIn 0.8s ease-in-out both;
  animation: act-7-fadeIn 0.8s ease-in-out both;
  animation-delay: 500ms;
  -webkit-animation-delay: 500ms;
}

.act-7-banner-title-contents {
    position: absolute;
    top: 59%;
    left: 6%;
    width: 74%;
    max-width: 100%;
}
/* 大标题 end */ 



/* 蜻蜓 */

@keyframes act-7-frames-dragonfly {
  0% { 
    -webkit-transform: translateY(0%)  translateX(0%);
    transform: translateY(0%)  translateX(0%);
  } 
  100% {
    -webkit-transform: translateY(330%)  translateX(-300%);
    -webkit-transform-origin: center center;        
    transform:  translateY(330%)  translateX(-300%);
    transform-origin: center center;
  }
}

.act-7-animation-dragonfly {    
  -webkit-animation: act-7-frames-dragonfly 2s linear both;  
  animation: act-7-frames-dragonfly 2s linear both;
  animation-delay: 100ms;
  -webkit-animation-delay: 100ms;
}

.act-7-banner-dragonfly{  
  position: absolute;
  width: 30%;
  max-width: 100%;
  left: 167%;
  top: -51%;
}

/* 蜻蜓 end */





/* 荷叶群 */
.act-7-banner-lotus-wrap{
  position: absolute;
  width: 100%;
  left: 0;
  top: 27%;
}
.act-7-banner-lotus-leaves {
  width: 100%;
  max-width: 100%;
}
/* 荷叶群 end */



/* fish */
.act-7-banner-fish {
  position: absolute;
  width: 30%;
  left: 36%;
  top: 38%;
}
/* fish end */


/* 荷花 */


@keyframes act-7-frames-lotus-1 {
  0% { 
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  50% {
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  100% {
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
}
@-webkit-keyframes act-7-frames-lotus-1 {
  0% { 
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  50% {
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  100% {
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
}


.act-7-animation-lotus-1 { 
  -webkit-animation: act-7-frames-lotus-1 2.5s ease-out infinite; 
  animation: act-7-frames-lotus-1 2.5s ease-out infinite;
}

.act-7-banner-lotus-1 {
  position: absolute;
  width: 27%;
  left: 67%;
  top: -19%;
  transform:rotate(-5deg);
  -webkit-transform:rotate(-5deg);
}



@keyframes act-7-frames-lotus-2 {
  0% { 
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  50% {
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  100% {
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
}
@-webkit-keyframes act-7-frames-lotus-2 {
  0% { 
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  50% {
    transform:rotate(-5deg);
    -webkit-transform:rotate(-5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
  100% {
    transform:rotate(5deg);
    -webkit-transform:rotate(5deg);
    transform-origin: bottom;
    -webkit-transform-origin: bottom;
  }
}

.act-7-animation-lotus-2 { 
  -webkit-animation: act-7-frames-lotus-2 2.5s ease-out infinite; 
  animation: act-7-frames-lotus-2 2.5s ease-out infinite;
}

.act-7-banner-lotus-2 {
  position: absolute;
  width: 17%;
  left: 61%;
  top: 14%;
  transform:rotate(5deg);
  -webkit-transform:rotate(5deg);
}


.act-7-banner-lotus-3 {
  position: absolute;
  width: 33%;
  left: 11%;
  top: 34%;
  transform:rotate(-5deg);
  -webkit-transform:rotate(-5deg);
}

 
.act-7-banner-lotus-4 {
  position: absolute;
  width: 15%;
  left: 51%;
  top: 56%;
  transform:rotate(5deg);
  -webkit-transform:rotate(5deg);
}
/* 荷花 end */


/* 荷叶 */

.act-7-banner-leaves-1 {
  position: absolute;
  width: 27%;
  left: 67%;
  top: 35%;
}
.act-7-banner-leaves-2 {
  position: absolute;
  width: 30%;
  left: 44%;
  top: 78%;
}
.act-7-banner-leaves-3 {
  position: absolute;
  width: 49%;
  left: 0;
  top:79.5%;
}
.act-7-banner-leaves-4 {
  position: absolute;
  width: 40%;
  right: 0;
  top: 82%;
}
/* 荷叶 end */ 

/* 按钮 end */ 

.act-7-animation-banner-btn-mtj { 
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both; 
  animation: act-7-fadeIn 0.8s ease-in-out both;
  animation-delay: 700ms;
  -webkit-animation-delay: 700ms;
}
.act-7-banner-btn-mtj {
  position: absolute;
  width: 10%;
  left: 60%;
  top: -28%;
}
.act-7-banner-btn-layer {
  height:25%;
}
.act-7-animation-banner-btn-spj { 
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both; 
  animation: act-7-fadeIn 0.8s ease-in-out both;
  animation-delay: 800ms;
  -webkit-animation-delay: 800ms;
}
.act-7-banner-btn-spj {
  position: absolute;
  width: 10%;
  left: 75%;
  top: 10%;
}
.act-7-animation-banner-btn-ssj { 
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both; 
  animation: act-7-fadeIn 0.8s ease-in-out both;
  animation-delay: 900ms;
  -webkit-animation-delay: 900ms;
}
.act-7-banner-btn-ssj {
  position: absolute;
  width: 10%;
  left: 63%;
  top: 53%;
}
.act-7-animation-banner-btn-yyj { 
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both; 
  animation: act-7-fadeIn 0.8s ease-in-out both;
  animation-delay: 1000ms;
  -webkit-animation-delay: 1000ms;
}
.act-7-banner-btn-yyj {
  position: absolute;
  width: 10%;
  left: 7%;
  top: 31%;
}
/* 按钮 */ 


/* 美图卷 */
.act-7-main-widnow-mtj,.act-7-main-gallery{
   position:fixed;
   left:50%;
   top:40%;
   width:94%;
   transform:translate(-50%,-40%);
   z-index:1000; 
}
.act-7-main-widnow-mtj-bg{
  width: 100%;
} 
.act-7-main-widnow1-btn-close{
  position: absolute;
  right: 2%;
  top: -1.5%;
  width: 5%;
  padding: 7%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.act-7-main-widnow1-p1,.act-7-main-widnow1-p2,.act-7-main-widnow1-p3 {  
    position: absolute;
    top: 17%;
    width: 28%;
    height: 56%;
}
.act-7-main-widnow1-p1{
    left: 4%;
}
.act-7-main-widnow1-p2{
    left: 36%;
}
.act-7-main-widnow1-p3{
    left: 67%;
}

/* 美图卷 end */


/* 图集 */
.act-7-main-gallery-title{
    position: absolute;
    top: 15.5%;
    left: 0;
    width: 98%;
    font-size: 0.3rem;
    text-align: center;
    color: #4e4e4e;
}









.act-3-desc-content::-webkit-scrollbar {
  width: 7px;
  /*滚动条宽度*/
  height: 7px;
  /*滚动条高度*/
}



/*定义滚动条轨道 内阴影+圆角*/

.act-3-desc-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  /*滚动条的背景区域的圆角*/
  background-color: rgba(111, 111, 111, 1);
  /*滚动条的背景颜色*/
}


/*定义滑块 内阴影+圆角*/

.act-3-desc-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #FFFFFF;
  /*滚动条的背景颜色*/
}

.act-3-contents-1 {
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}
.act-3-banner-1{
  margin-top: 20px;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") !important;  
  background-size: 38%;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") !important;  
  background-size: 38%;
} 

.act-3-contents-2{
  margin-top: 20px;
}
 

.act-3-banner-2{
  margin-top: 20px;
}
.act-7-main-gallery-swiper-wrap{
  position: absolute;
  top: 23%;
  left: 5%;
  width: 88%; 
}
.swiper-slide img{
  width: 100%;
  opacity: 1;
  object-fit: cover;
}
.swiper-button-next,.swiper-button-prev{
  background-color:rgba(42, 82, 117, 0.8);   
  top:43%;
  width: 6%;
  height: 16%;
}
.swiper-button-next{
  right:1.7%;
}
.swiper-button-prev{
  left:0;
}
.swiper-page-info{
  position: absolute;
  top: 74%;
  left: 0;
  width: 98%;
  font-size: 0.25rem;
  text-align: center;
  color: #4e4e4e;
  font-weight: 300;
}
/* 图集 end */

/* 视频卷 */
.video{
  position: absolute;
  top: 25%;
  left: 5%;
  width: 90%;
}
/* 视频卷 end */

/* 身世卷 */
.ssj-contents{
    position: absolute;
    top: 12%;
    left: 4%;
    width: 90%;
    height: 64%;
    overflow-y: scroll;
    color: #4f4f4f;
    font-size: 12px;
}
.ssj-contents img{
  width:100%;
}

/* 身世卷 end */


/* 友谊卷 */
.yyj-contents{
    position: absolute;
    top: 12%;
    left: 4%;
    width: 90%;
    height: 64%;
    overflow-y: scroll;
    color: #4f4f4f;
    font-size: 12px;
}
.yyj-contents img{
  width:100%;
  object-fit: cover;
}
.yyj-contents li{
  margin: 0;
  padding: 1%;
  width:29.9%;
  display:inline-table;
  margin-bottom: 10px;
}

.yyj-item-title{
  text-align: center;
  margin-top: 5px;
}
/* 友谊卷 end */ 
.ssj-contents-item-title{
  font-size: 0.3rem;
  text-align: center;
  font-weight: bold;
  margin-top: 18px;
}
.ssj-contents-item-address{
  font-size: 0.3rem;
  font-weight: bold;
  margin-top: 18px;
}

</style>
<style>

.lanren-wrap{
  position:fixed;
  top: -92px;
  right: 10px;
}


#lanren #audio-btn{
  width: 30px;
  height: 30px;
  margin:100px auto;
  background-size: 100% 100%;
}

#lanren .on{background: url(../../../../static/img/act/7/music_on.png) no-repeat 0 0;-webkit-animation: rotating 1.2s linear infinite;animation: rotating 1.2s linear infinite;}
#lanren .off{background: url(../../../../static/img/act/7/music_off.png) no-repeat 0 0;}
@-webkit-keyframes rotating {
	from{
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-ms-transform: rotate(0deg);
		-o-transform: rotate(0deg);
    	transform: rotate(0deg);
	}
	to{
		-webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes rotating {
    from{
        -webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-ms-transform: rotate(0deg);
		-o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to{
        -webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/act/7/Main.vue